import type { JSX } from 'react';
import { FormButtonRow } from '@ksyos/design-system';
import { ManagerAuthorization } from '@common/enums/managerAuthorization';
import { CancelButton } from '@frontend/components/userDataManagement/CancelButton';
import { SaveButton } from '@frontend/components/userDataManagement/SaveButton';
import { hasOneAuthorization } from '@frontend/utils/hasAuthorization';
import { ServiceOrganizationSettingFormMode } from '../ServiceOrganizationSetting';

type ServiceOrganizationSettingButtonsProps = {
    isSaving: boolean;
    mode: ServiceOrganizationSettingFormMode;
    onClose: () => Promise<void>;
    onSave: () => Promise<void>;
};

export function ServiceOrganizationSettingButtons(props: ServiceOrganizationSettingButtonsProps): JSX.Element | null {
    const { isSaving, mode, onClose, onSave } = props;
    const canEdit = hasOneAuthorization(ManagerAuthorization.organizationAddEdit);

    if (!canEdit || mode !== ServiceOrganizationSettingFormMode.edit) {
        return null;
    }

    return (
        <FormButtonRow>
            <CancelButton
                disabled={isSaving}
                onCancel={onClose}
            />
            <SaveButton
                disabled={isSaving}
                onSave={onSave}
            />
        </FormButtonRow>
    );
}
